export default function compressLongString(
  id: string,
  startLength: number = 6,
  endLength: number = 4
): string {
  if (id.length <= startLength + endLength) {
    return id;
  }
  return `${id?.slice(0, startLength)}...${id.slice(-endLength)}`;
}
